// Settings › People › Directory: people and groups from the organisation's Microsoft 365 or Google Workspace
// (and SCIM provisioning) — owner: S10 (settings IA).
import { createFileRoute } from '@tanstack/react-router';
import { DirectoryPage } from '../../../features/access/DirectoryPage';

export const Route = createFileRoute('/_settings/settings/directory')({ component: DirectoryPage });
